import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateCidade } from './can-activate-cidade';
import { CidadeComponent } from './cidade.component';
import { CidadeFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateCidade],
                children: [
                    {path: '', component: CidadeComponent},
                    {path: 'novo', component: CidadeFormComponent},
                    {path: ':id', component: CidadeFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateCidade
    ]
})
export class CidadeRoutingModule { }
